module.exports = __webpack_public_path__ + "af2a0a6365c456ce4988aa307a1d669d.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/fontello/fontello.svg?67495670
// module id = 965
// module chunks = 0